import { addToEndOfChain, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { createFromProduct } from "@insite/client-framework/Common/ProductInfo";
import { getSearchDataModeActive } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    chain,
    SetExpandTokens,
    SetUpProductInfos,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import { dispatchProductImpressions } from "@store/Framework/Services/AnalyticsService";

const enum pageType {
    productListPage = "Product List Page",
    searchPage = "Search Page",
}

replaceInChain(chain, SetExpandTokens, props => {
    props.expandTokens = ["attributes", "facets", "documents"]; // Store Custom Code

    if (getSearchDataModeActive(props.getState())) {
        props.expandTokens.push("scoreexplanation");
    }
});

replaceInChain(chain, SetUpProductInfos, props => {
    const categoryPath = props.apiParameter.search ? undefined : props.result.catalogPage?.displayPath;

    props.idByPath = {};

    props.result.products?.forEach(product => {
        if (props.result.productInfosByProductId[product.id]) {
            return;
        }
        /* Store Custom Code - Start */
        const productDetailPath = product.canonicalUrl;
        if (productDetailPath) {
            props.idByPath![productDetailPath] = product.id;
        }
        /* Store Custom Code - End */
        props.result.productInfosByProductId[product.id] = {
            ...createFromProduct(product),
            productDetailPath,
        };
    });
});

addToEndOfChain(chain, props => {
    const state = props.getState();
    const currency = state.context.session.currency?.currencyCode;
    const { isSearch } = props.parameter;
    const { products } = props.result;
    let page = pageType.productListPage;

    if (isSearch) {
        page = pageType.searchPage;
    }
    if (products && products?.length > 0) {
        dispatchProductImpressions(products, currency, page);
    }
});
